import {
	AddPendingTipRequest,
	CanChangeInvoicePaymentRequest,
	CanChangeInvoicePaymentResponse,
	CanChangeInvoicePaymentResultDTO,
	CanOpenDayRequest,
	CanOpenDayResponse,
	CheckPaymentsRequest,
	CheckPaymentsResponse,
	CloseBusinessDayRequest,
	CreatePaymentOperationRequest,
	CreatePaymentOperationResponse,
	DeleteTrainingActivityRequest,
	ExtractPendingTipRequest,
	GetCurrentAmountRequest,
	GetCurrentAmountResponse,
	GetCurrentBalancesRequest,
	GetCurrentBalancesResponse,
	GetCurrentBusinessDayRequest,
	GetCurrentBusinessDayResponse,
	GetOpenDayParamsRequest,
	GetOpenDayParamsResponse,
	GetPaymentMethodsForPhoneOrderRequest,
	GetPaymentMethodsForPhoneOrderResponse,
	GetPendingTipToExtractRequest,
	GetPendingTipToExtractResponse,
	IsThereTrainingActivityRequest,
	IsThereTrainingActivityResponse,
	OpenBusinessDayRequest,
	OpenCashdrawerRequest,
	OpenDayParamsDTO,
	PaymentDTO,
	PaymentMethodBalanceDTO,
	PaymentMethodDTO,
	PaymentOperationDTO,
	PaymentsStatusDTO,
	RegisterCashTransactionRequest,
	RegisterCashTransactionResponse,
	RegisterCashTransactionResultDTO
} from 'core/api';

import { Bus } from 'core/infrastructure';
const process = Bus.buildProcessFn('/bus/');

export function isThereTrainingActivity(): Promise<boolean> {
	const request = new IsThereTrainingActivityRequest();
	return process(request, (response: IsThereTrainingActivityResponse) => response.IsThereTrainingActivity);
}

export function deleteTrainingActivity(): Promise<void> {
	const request = new DeleteTrainingActivityRequest();
	return process(request);
}

export function getCurrentBalances(): Promise<PaymentMethodBalanceDTO[]> {
	const request = new GetCurrentBalancesRequest();
	return process(request, (response: GetCurrentBalancesResponse) => response.Balances);
}

export function closeDay(balances: PaymentMethodBalanceDTO[], incident: string): Promise<void> {
	const request = new CloseBusinessDayRequest({ balances, incident });
	return process(request);
}

export function checkPayments(payments: PaymentDTO[], amountToPay: number, isRefund = false): Promise<PaymentsStatusDTO> {
	const request = new CheckPaymentsRequest({ payments, amountToPay, isRefund });
	return process(request, (response: CheckPaymentsResponse) => response.Result);
}

export function createPaymentOperation(isForRefund = false): Promise<PaymentOperationDTO> {
	const request = new CreatePaymentOperationRequest({ isForRefund });
	return process(request, (response: CreatePaymentOperationResponse) => response.PaymentOperation);
}

export async function canChangeInvoicePayment(invoiceId: number): Promise<CanChangeInvoicePaymentResultDTO> {
	const request = new CanChangeInvoicePaymentRequest({ invoiceId });
	return process(request, (response: CanChangeInvoicePaymentResponse) => response.Result);
}

export function getCurrentBusinessDay(): Promise<Nullable<Date>> {
	const request = new GetCurrentBusinessDayRequest();
	return process(request, (response: GetCurrentBusinessDayResponse) => response.BusinessDay);
}

export function canOpenDay(): Promise<{ canOpen: boolean, reason: string }> {
	const request = new CanOpenDayRequest();
	return process(request, (response: CanOpenDayResponse) => { return { canOpen: response.CanOpen, reason: response.Reason }; });
}

export function getOpenDayParams(): Promise<OpenDayParamsDTO> {
	const request = new GetOpenDayParamsRequest();
	return process(request, (response: GetOpenDayParamsResponse) => response.Params);
}

export function openDay(expectedSystemBusinessDay: Nullable<Date>, businessDay: Date, initialAmount: number): Promise<void> {
	const request = new OpenBusinessDayRequest({ expectedSystemBusinessDay, businessDay, initialAmount });
	return process(request);
}

export function getPaymentMethodsForPhoneOrder(): Promise<PaymentMethodDTO[]> {
	const request = new GetPaymentMethodsForPhoneOrderRequest();
	return process(request, (response: GetPaymentMethodsForPhoneOrderResponse) => response.Methods);
}

export function getPendingTipToExtract(): Promise<number> {
	const request = new GetPendingTipToExtractRequest();
	return process(request, (response: GetPendingTipToExtractResponse) => response.PendingTipToExtract);
}

export function extractPendingTip(tipToExtract: number): Promise<void> {
	const request = new ExtractPendingTipRequest({ tipToExtract });
	return process(request);
}

export function addPendingTip(tipToAdd: number): Promise<void> {
	const request = new AddPendingTipRequest({ tipToAdd });
	return process(request);
}


export async function openCashdrawer(): Promise<void> {
	const request = new OpenCashdrawerRequest();
	await process(request);
}

export async function registerInputOperation(provider: string, description: string, amount: number, printReceipt: boolean, isCashControlDiscrepancyAmount: boolean, date: Nullable<Date> = null): Promise<RegisterCashTransactionResultDTO> {
	const request = new RegisterCashTransactionRequest({ provider, description, amount, printReceipt, isCashControlDiscrepancyAmount, date });
	return await process(request, (response: RegisterCashTransactionResponse) => response.Result);
}

export async function registerOutputOperation(provider: string, description: string, amount: number, printReceipt: boolean, isCashControlDiscrepancyAmount: boolean, date: Nullable<Date> = null): Promise<RegisterCashTransactionResultDTO> {
	if (amount <= 0)
		throw Error('El importe extraído de la caja debe indicarse en positivo');
	const request = new RegisterCashTransactionRequest({ provider, description, amount: -amount, printReceipt, isCashControlDiscrepancyAmount, date });
	return await process(request, (response: RegisterCashTransactionResponse) => response.Result);
}

export async function getCurrentAmount(): Promise<number> {
	const request = new GetCurrentAmountRequest();
	return await process(request, (response: GetCurrentAmountResponse) => response.Amount);
}